import { getSelectedTableView, type TableQueryType } from "owa-mail-list-store";
import type { OwaDate } from "owa-datetime";
import { lazyScheduleRows } from "owa-mail-triage-action";
import type { ActionSource } from "owa-analytics-types";
import { startAnimationOrHandleActionAsNeeded } from "owa-mail-list-item-animation-store";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";
import folderNameToId from "owa-session-store/lib/utils/folderNameToId";
import { getMailboxInfo } from "owa-mail-mailboxinfo";

export default async function onSnooze(date: OwaDate | undefined, actionSource: ActionSource): Promise<void> {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    const rowKeys = getEffectiveRowKeys(tableView);
    if (tableView && rowKeys) {
        const scheduleRows = await lazyScheduleRows.import();
        const handleScheduleRows = () => {
            scheduleRows(rowKeys, tableView.id, actionSource, date);
        };
        
        if (date !== undefined &&
            tableView.tableQuery.type === 0 &&
            tableView.tableQuery.folderId === folderNameToId("scheduled", getMailboxInfo(tableView))) {
            handleScheduleRows();
            return;
        }
        
        startAnimationOrHandleActionAsNeeded("Snooze" /*actionId*/, rowKeys, actionSource, false /*isActionTakenFromDialog*/, handleScheduleRows);
    }
}
